import { apiClient } from './api';

export interface TaxComplianceOverview {
  active_jurisdictions: number;
  states_configured: number;
  states_total: number;
  restricted_products: number;
  tax_rule_conflicts: number;
  blocked_orders_today: number;
}

export interface ComplianceActivity {
  id: number;
  title: string;
  description: string;
  occurred_at: string;
  source: string;
  kind: 'rule_update' | 'product_restricted' | 'exemption' | 'order_blocked' | 'other';
}

export interface ComplianceAlert {
  level: 'info' | 'warning' | 'critical';
  title: string;
  subtext: string;
}

export async function getOverview(): Promise<TaxComplianceOverview> {
  return apiClient.get<TaxComplianceOverview>('/tax-compliance/overview');
}

export async function getActivity(limit = 10): Promise<ComplianceActivity[]> {
  const raw = await apiClient.get<any>('/tax-compliance/activity', { limit });
  return Array.isArray(raw) ? raw : (raw?.data ?? []);
}

export async function getAlerts(): Promise<ComplianceAlert[]> {
  const raw = await apiClient.get<any>('/tax-compliance/alerts');
  return Array.isArray(raw) ? raw : (raw?.data ?? []);
}

/** Sec 12 — server-side CSV export (GET /tax-compliance/activity?format=csv). */
export async function downloadActivityCsv(limit = 100): Promise<Blob> {
  return apiClient.downloadBlob('/tax-compliance/activity', { limit, format: 'csv' });
}
